import { Badge, BadgeProps } from '@anyui/core';
import { TikTokSpecialCampaignStatus } from '@anytag/graphql';
import { useTikTokCampaignStatusOptions } from '../TikTokCampaignsFilter';

export interface TikTokCampaignStatusProps {
  className?: string;
  status?: TikTokSpecialCampaignStatus;
}

export const TikTokCampaignStatus = ({ status, className }: TikTokCampaignStatusProps) => {
  const { statusOptions } = useTikTokCampaignStatusOptions();

  const children = statusOptions.find((o) => o.value === status)?.label || '';
  const statusProps = ((): BadgeProps => {
    switch (status) {
      case TikTokSpecialCampaignStatus.DRAFT:
        return { children, color: 'yellow' };
      case TikTokSpecialCampaignStatus.REVIEWING:
        return { children, color: 'purple' };
      case TikTokSpecialCampaignStatus.UPCOMING:
        return { children, color: 'blue' };
      case TikTokSpecialCampaignStatus.ONGOING:
        return { children, color: 'green' };
      case TikTokSpecialCampaignStatus.SUSPENDED:
        return { children, color: 'red' };
      case TikTokSpecialCampaignStatus.REJECTED:
      default:
        return { children, color: 'zinc' };
    }
  })();

  return <Badge className={className} {...statusProps} />;
};
